import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fi from "date-fns/locale/fi";
import './App.css';
// Rekisteröidään Suomen kieli
registerLocale("fi", fi);

function App() {
  const [isAuthorized, setIsAuthorized] = useState(false); // Tila kirjautumiselle
  const [password, setPassword] = useState("");
  const [formData, setFormData] = useState({
    bookingDate: null,
    bookingTime: null,
    companyName: "",
    businessID: "",
    contactFirstName: "",
    contactLastName: "",
    contactTitle: "",
    contactPhone: "",
    contactEmail: "",
    generalInfo: "",
  });

  const [responseMessage, setResponseMessage] = useState("");
  
  // Oikea salasana
  const correctPassword = "salakka";

  // Tarkista kirjautumistila localStoragesta
  useEffect(() => {
    const savedAuth = localStorage.getItem("isAuthorized");
    if (savedAuth === "true") {
      setIsAuthorized(true);
    }
  }, []);

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (password === correctPassword) {
      setIsAuthorized(true);
      localStorage.setItem("isAuthorized", "true"); // Tallenna kirjautumistila localStorageen
    } else {
      alert("Virheellinen salasana. Yritä uudelleen.");
    }
  };

  const handleLogout = () => {
    setIsAuthorized(false);
    localStorage.removeItem("isAuthorized"); // Poista kirjautumistila localStoragesta
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/client/create`, formData, {
            headers: {
                Authorization: `Bearer ${process.env.REACT_APP_BEARER_TOKEN}`,
            }
        });

        setResponseMessage(response.data.message);
    } catch (error) {
        console.error('Virhe:', error);
        setResponseMessage('Virhe asiakkaan luomisessa.');
    }
};



  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      {!isAuthorized ? (
        <form
          onSubmit={handlePasswordSubmit}
          className="bg-white p-6 rounded-lg shadow-md w-full max-w-sm"
        >
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Salasana"
            className="w-full p-2 border rounded-lg mb-4"
            required
          />
          <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded-lg">
            Lähetä
          </button>
        </form>
      ) : (
        <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-4xl">
          <div className="flex justify-between items-center mb-6">
              
              <div>
              <h1 className="text-2xl font-semibold">Varauslomake</h1>
              
                <p>
                  <span className="required">*</span> -merkityt ovat pakollisia täyttää. Mikäli olet julkisella koneella, muista kirjautua ulos.
                </p>
              </div>
              
                <button
              onClick={handleLogout}
              className="bg-red-500 text-white px-4 py-2 rounded-lg"
            >
              Kirjaudu ulos
            </button>
          </div>
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Ajankohta */}
            <div className="datafield">
              <h2 className="text-xl font-semibold mb-4">Ajankohta</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label
                    htmlFor="bookingDate"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Päivämäärä:
                  </label>
                  <ReactDatePicker
                    selected={formData.bookingDate}
                    onChange={(date) => setFormData({ ...formData, bookingDate: date })}
                    dateFormat="dd.MM.yyyy"
                    placeholderText="Valitse päivämäärä"
                    locale="fi"
                    className="w-full"
                    
                  />
                </div>

                <div>
                  <label
                    htmlFor="bookingTime"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Kellonaika:
                  </label>
                  <ReactDatePicker
                    selected={formData.bookingTime}
                    onChange={(time) => setFormData({ ...formData, bookingTime: time })}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Aika"
                    dateFormat="HH:mm"
                    locale="fi"
                    className="w-full"
                   
                  />
                </div>
              </div>
            </div>

            {/* Yrityksen tiedot */}
            <div className="datafield">
              <h2 className="text-xl font-semibold mb-4">Yrityksen tiedot</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label
                    htmlFor="companyName"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Yrityksen nimi<span className="required">*</span>:
                  </label>
                  <input
                    type="text"
                    id="companyName"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleChange}
                    className="w-full p-2 border rounded-lg"
                    required
                  />
                </div>
                <div>
                  <label
                    htmlFor="businessID"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Y-tunnus<span className="required">*</span>:
                  </label>
                  <input
                    type="text"
                    id="businessID"
                    name="businessID"
                    value={formData.businessID}
                    onChange={handleChange}
                    className="w-full p-2 border rounded-lg"
                    required
                  />
                </div>
              </div>
            </div>

            {/* Yhteyshenkilö */}
            <div className="datafield">
              <h2 className="text-xl font-semibold mb-4">Yhteyshenkilö</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label
                    htmlFor="contactFirstName"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Etunimi<span className="required">*</span>:
                  </label>
                  <input
                    type="text"
                    id="contactFirstName"
                    name="contactFirstName"
                    value={formData.contactFirstName}
                    onChange={handleChange}
                    className="w-full p-2 border rounded-lg"
                    required
                  />
                </div>
                <div>
                  <label
                    htmlFor="contactLastName"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Sukunimi<span className="required">*</span>:
                  </label>
                  <input
                    type="text"
                    id="contactLastName"
                    name="contactLastName"
                    value={formData.contactLastName}
                    onChange={handleChange}
                    className="w-full p-2 border rounded-lg"
                    required
                  />
                </div>
                <div>
                  <label
                    htmlFor="contactTitle"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Titteli:
                  </label>
                  <input
                    type="text"
                    id="contactTitle"
                    name="contactTitle"
                    value={formData.contactTitle}
                    onChange={handleChange}
                    className="w-full p-2 border rounded-lg"
                  />
                </div>
                <div>
                  <label
                    htmlFor="contactPhone"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Puhelinnumero<span className="required">*</span>:
                  </label>
                  <input
                    type="tel"
                    id="contactPhone"
                    name="contactPhone"
                    value={formData.contactPhone}
                    onChange={handleChange}
                    className="w-full p-2 border rounded-lg"
                    required
                  />
                </div>
                <div>
                  <label
                    htmlFor="contactEmail"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Sähköposti<span className="required">*</span>:
                  </label>
                  <input
                    type="email"
                    id="contactEmail"
                    name="contactEmail"
                    value={formData.contactEmail}
                    onChange={handleChange}
                    className="w-full p-2 border rounded-lg"
                    required
                  />
                </div>
              </div>
            </div>

            {/* Yleistä tietoa */}
            <div className="datafield">
              <h2 className="text-xl font-semibold mb-4">Yleistä tietoa</h2>
              <div>
                <label
                  htmlFor="generalInfo"
                  className="block text-sm font-medium text-gray-700"
                >
                  Lisätiedot:
                </label>
                <textarea
                  id="generalInfo"
                  name="generalInfo"
                  value={formData.generalInfo}
                  onChange={handleChange}
                  className="w-full p-2 border rounded-lg"
                  rows="4"
                />
              </div>
            </div>

            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 rounded-lg"
            >
              Lähetä
            </button>
          </form>
            {responseMessage && (
              <p
                className={`mt-4 ${responseMessage.includes('Virhe') ? 'text-red-500' : 'text-green-500'
                  }`}
              >
                {responseMessage}
              </p>
            )}

        </div>
      )}
    </div>
  );
}

export default App;
